'use client';

import React from 'react';

import { ProductTracking } from '@/app/[locale]/products/[slug]/components/ProductTracking';
import { useProductView } from '@/modules/product/hooks/useProductView';

export function InitProduct() {
  useProductView();

  return <ProductTracking />;
}
